import {ActionAllowed} from './actionAllowed';
import {AppSection} from './appSection';
import {AppSectionData} from './appSectionData';

export class RolPermission {
    appSection:AppSection;
    visible:boolean;
    actions:ActionAllowed[] = [];
    sectionFields:AppSection[];
    constructor(other ?:RolPermission) {
        if (other) {
            this.appSection = other.appSection;
            this.visible = other.visible;
            this.actions = other.actions;
            this.appSection = other.appSection;
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/app/domain/rolPermission.ts
 **/